import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { CheckCircle } from "lucide-react";
export default function IhrExperteFuerHochdruckreinigungUndGartenpflegeInHavixbe() {
  const benefits = ["Flächenreinigung ohne chemische Zusätze", "Hausmeisterservice im nicht handwerkspflichtigen Bereich", "Gartenpflege und saisonale Pflege", "Bürotätigkeiten und Organisationshilfe"];
  return <section className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1410631/img/professional_services_clean_surfaces_organized_workspace.png)] overflow-hidden">
      {}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px]" />
      
      {}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        
        {}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-fade-in-up">
          Ihr vielseitiger Dienstleister im Münsterland
        </h1>
        
        {}
        <p className="text-xl sm:text-2xl text-white/95 font-medium mb-4 animate-fade-in-up-delay-100">
          Münsterland Industrieservice  – Vier Leistungsbereiche, ein zuverlässiger Partner
        </p>
        
        {}
        <p className="text-base sm:text-lg text-white/90 max-w-3xl mx-auto mb-8 leading-relaxed animate-fade-in-up-delay-200">
          Professionelle Flächenreinigung ohne chemische Zusätze, zuverlässige Hausmeistertätigkeiten im nicht handwerkspflichtigen Bereich, 
          umfassende Gartenpflege sowie Bürotätigkeiten und Hilfeleistungen im Bereich Büroorganisation in Havixbeck und Umgebung. 
          Vertrauen Sie auf unsere vielseitige Expertise im Münsterland.
        </p>
        
        {}
        <div className="flex flex-wrap justify-center gap-4 sm:gap-6 mb-10 animate-fade-in-up-delay-200">
          {benefits.map((benefit, i) => <div key={i} data-index={i} className="flex items-center gap-2 text-white/95">
              <CheckCircle className="size-5 text-[#64D6C0] shrink-0" />
              <span className="text-sm sm:text-base font-medium">{benefit}</span>
            </div>)}
        </div>
        
        {}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-up-delay-200">
          <Link to="/KontaktPage">
            <Button size="lg" className="bg-[#64D6C0] text-white hover:bg-[#5ac2b5] shadow-medium px-8 py-4 text-base sm:text-lg font-semibold rounded-lg transition-all duration-300 hover:-translate-y-1 focus-ring">
              Kostenloses Angebot anfordern
            </Button>
          </Link>
          
          <Link to="/ReinigungPage">
            <Button variant="outline" size="lg" className="bg-white/95 text-[#2B2D2F] hover:bg-white border-white shadow-medium px-8 py-4 text-base sm:text-lg font-semibold rounded-lg transition-all duration-300 hover:-translate-y-1 focus-ring">
              Unsere Leistungen
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}